import { CustomAutoComplete } from 'components/shared/CustomAutoComplete';
import { CustomButton } from 'components/shared/CustomButton';
import React, { InputHTMLAttributes, useEffect, useState } from 'react' 
import { Col, Modal, Row } from 'reactstrap';

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    assigneeList: any,
    aliasname: any,
    setModelOpen: any,
    modalOpen: any,
    getTechnicianAssigneeId: any,
    isAssigned: any
}


function AssigneeModal({ assigneeList, aliasname, modalOpen, setModelOpen, getTechnicianAssigneeId,isAssigned }: inputProps) {
    const [TechnicianAssignId, setTechnicianAssignId] = useState<number>(0);
    const [isClicked, setIsClicked] = useState<boolean>(false);



    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function tog_center() {
        setModelOpen(!modalOpen);
        removeBodyCss();
    }

    
    useEffect(() => {
        setTechnicianAssignId(0)
    },[modalOpen])
    // getTechnicianAssigneeId(TechnicianAssignId);

    return (
        <Modal
            isOpen={modalOpen}
            toggle={() => tog_center()}
            centered
        >
            <div className="modal-body">
                <Row className='mb-1'>
                    <Col xl={10} lg={10} md={10} sm={8} xs={8}>
                        <div className=''>
                            <i className='fas fa-motorcycle text-dofy me-2 font-size-15 '></i>
                            <span className='font-size-16 fw-semibold text-dofy'>Assign Rider</span>
                        </div>
                    </Col>
                    <Col className='' xl={2} lg={2} md={2} sm={4} xs={4}>
                        <i className='bx bx-x font-size-18 cursor-pointer float-end' onClick={() => tog_center()}></i>
                    </Col>
                </Row>
                <div>
                    {/* <CustomDropdown label={'Assignee'} id={undefined} value={TechnicianAssignId} data={aliasname} error={undefined} valueField='Id' displayField='AliasName' onChange={(e) => setTechnicianAssignId(e.target.value)} /> */}
                    <CustomAutoComplete label={"Assignee"} data={assigneeList} name={undefined} value={TechnicianAssignId} id={undefined} onChange={(e,v) => {setTechnicianAssignId(v.Id)}} error={undefined} touched={undefined} valueField='Id' displayField='FirstName' displayField3 ='LastName' displayField2='AliasName' defaultValue={undefined}/>
                </div>
                <div className='d-flex justify-content-end m-3'>
                    <CustomButton type={'button'} btnClassName={'btn-light me-2'} iconClasssName={'mdi mdi-close'} name={''} onClick={() => setModelOpen(false)} />
                    <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Assign'} onClick={() => { getTechnicianAssigneeId(TechnicianAssignId); }} disabled={TechnicianAssignId ==0 || isAssigned }   />
                </div>
            </div>
        </Modal>
    )
}

export default AssigneeModal
